import Typography from '@mui/material/Typography';
import React from 'react';

import { ContentCopyExtension } from 'common/ContentCopyExtension/ContentCopyExtension';
import { ValueBoxProps } from './TwoValueCell.interface';

export const ValueBox: React.FC<ValueBoxProps> = ({ text, variant, color, testId }) => {
  return (
    <ContentCopyExtension value={text}>
      <Typography data-testid={testId} variant={variant} color={color}>
        {text}
      </Typography>
    </ContentCopyExtension>
  );
};
